









































import TasksList from './TasksList.vue';
import {defineComponent, ref} from "@vue/composition-api";
import {useGetters, useActions} from "vuex-composition-helpers";

export default defineComponent({
  name: 'TaskSourceSystems',
  components: {
    TasksList
  },
  setup: () => {
    const {config, getSortedSourceSystems} = useGetters(['config', 'getSortedSourceSystems'])
    const {setSourceSystemNameSorting} = useActions(['setSourceSystemNameSorting'])
    const showTasks = ref(false);
    const sourceSystemsByNameOrder = ref('asc');
    const tasksByDateOrder = ref('asc');
    const tasksByStatusOrder = ref('asc');

    function setSourceSystemsByNameOrder() {
      sourceSystemsByNameOrder.value = sourceSystemsByNameOrder.value === 'asc' ? 'desc' : 'asc';
      setSourceSystemNameSorting(sourceSystemsByNameOrder.value);

    }

    function setTasksByDateOrder() {
      tasksByDateOrder.value = tasksByDateOrder.value === 'asc' ? 'desc' : 'asc';
    }

    function setTasksByStatusOrder() {
      tasksByStatusOrder.value = tasksByStatusOrder.value === 'asc' ? 'desc' : 'asc';
    }

    return {config, tasksByDateOrder, showTasks, setSourceSystemsByNameOrder, sourceSystemsByNameOrder, setTasksByDateOrder, tasksByStatusOrder, setTasksByStatusOrder, getSortedSourceSystems}
  }
})

